import { LocationFilterDTO, LocationSearchFilterId, SearchFilterDTO } from "../..";

const textSearchTypes: Record<LocationSearchFilterId, true> = {
  "search-location-id": true
};
export function isLocationSearchDTO(filter: SearchFilterDTO): filter is LocationFilterDTO {
  return filter.id in textSearchTypes;
}
